import axios from "axios";
import Config from "../../utils/config/config.js";
import store from "../../state/configureStore.js"; // Redux store
import { updateUserRoles } from "../../state/actions/user.js";
import { UserServiceClientApi } from "./UserApiServices.js";
import { Headers } from "../../utils/config/configHelpers/index.js";

const botFilesAPI = Config.botFilesAPI;

const configHeaders = () => ({
  headers: Headers(),
  timeout: 100000,
});

// File download services
const downloadBotFile = (botUrl) => {
  const url = `${botFilesAPI}${botUrl}`;
  return axios.get(url, configHeaders());
};

const downloadSignedUrlFile = (url) => {
  return axios.get(url, configHeaders());
};

const downloadFile = (url) => {

  return axios.get(url, {
    ...configHeaders(),
    responseType: "blob",
  });
};



// Activation service (dispatch must come from store)
export const activateEnterpriseBots = async (code) => {
  const response = await UserServiceClientApi.subscribeDomain({
    verificationCode: code,
  });

  if (!response?.data?.errorMessage) {
    // Use store.dispatch since we're outside a React component
    store.dispatch(updateUserRoles(response));
    return response?.data;
  }

  return response?.data;
};

// Expose download services
export const BotApiServices = {
  downloadBotFile,
  downloadSignedUrlFile,
  downloadFile,
  activateEnterpriseBots
};